import type { RowData } from '@tanstack/react-table';
import { useEffect } from 'react';

import type { DataTableInstance } from '../features/types/table.types.js';

/**
 * Remeasures all columns when row density changes, data is loaded, or the column definition changes.
 * @internal
 */
export function useColumnRemeasure<TData extends RowData>(
  table: DataTableInstance<TData>,
): void {
  const rowDensity = table.atoms.visualVariantConfig?.get().rowDensity;
  const rowCount = table.getRowModel().rows.length;

  useEffect(() => {
    if (rowCount > 0) {
      table.remeasureAllColumns();
    }
    // Explicitly do not add the table instance here as it mutates too often.
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [rowDensity, rowCount, table.options.columns]);
}
